import { Grid, useTheme, Stack, RichTextReader, Typography, Box, Card } from "@compass/core";
import { Form } from "generated/openApi";
import { useEffect } from "react";

type publicSurveySubmissionProps = {
  survey: Form;
};

export const PublicSurveySubmission = ({ survey }: publicSurveySubmissionProps) => {
  const theme = useTheme();

  useEffect(() => {}, []);

  return (
    <Card sx={{ maxWidth: "1100px", width: "100%" }}>
      <Stack px={3} py={7} spacing="lg" width="100%">
        <Grid container spacing="sm">
          <Grid item xs={12}>
            <RichTextReader html={survey.submitMessage} />
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
